import { Link as MuiLink, LinkProps } from "@mui/material";

type Props = LinkProps & {
  document: LegalDocumentKey;
};

type LegalDocumentKey =
  | "PrivacyNotice"
  | "PrivacyPolicy"
  | "TermsOfService"
  | "TermsOfUse"
  | "CloudServicesAgreement"
  | "ElectronicDelivery"
  | "RecurringPaymentNotice"
  | "TcpaDisclosure";

interface LegalDocument {
  href: string;
  text: string;
}

const legalDocuments: Record<LegalDocumentKey, LegalDocument> = {
  PrivacyNotice: {
    href: "https://covertree.com/legal_center/privacy-policy/",
    text: "Privacy Notice",
  },
  PrivacyPolicy: {
    href: "https://covertree.com/legal_center/privacy-policy/",
    text: "Privacy Policy",
  },
  TermsOfService: {
    href: "https://covertree.com/legal_center/terms-of-use/",
    text: "Terms of Service",
  },
  TermsOfUse: {
    href: "https://covertree.com/legal_center/terms-of-use/",
    text: "Terms of Use",
  },
  CloudServicesAgreement: {
    href: "https://covertree.com/legal_center/cloud-services-agreement/",
    text: "Cloud Services Agreement",
  },
  ElectronicDelivery: {
    href: "https://covertree.com/legal_center/electronic-delivery-notice/",
    text: "Electronic Delivery",
  },
  RecurringPaymentNotice: {
    href: "https://covertree.com/legal_center/recurring-payment-notice/",
    text: "Recurring Payment Notice",
  },
  TcpaDisclosure: {
    href: "https://covertree.com/legal_center/tcpa-disclosure/",
    text: "TCPA Disclosure",
  },
};

export function LegalDocumentLink({ document, ...props }: Props) {
  const details = legalDocuments[document];

  const updatedProps: LinkProps = {
    href: details.href,
    target: "_blank",
    color: "secondary",
    ...props,
  };

  return <MuiLink {...updatedProps}>{details.text}</MuiLink>;
}
